
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { FormioAppConfig } from 'dp-formio';
@Injectable({ providedIn: 'root' })
export class TemplateObjectsService {
  PROCESS_HOST_URL = '';

  constructor(private httpClient: HttpClient,
    private formioAppConfig: FormioAppConfig) { }

  getCollaburaURL(): Observable<{ url?: string, token?: string }> {
    return this.httpClient.get<{ url?: string, token?: string }>(this.PROCESS_HOST_URL + '/api/collaboraUrl');
  }
  // parseTemplate(data: string): Observable<any> {
  //   return this.httpClient.post(this.PROCESS_HOST_URL + '/api/documenteditor/OpenBase64', {
  //     documentData: data,
  //     fileName: ''
  //   });
  // }

  // mergeAndParseTemplate(requestData: any): Observable<any> {
  //   return this.httpClient.post(this.PROCESS_HOST_URL + '/api/documenteditor/MailMerge', requestData);
  // }

  // mergeAndRenderTemplate(requestData: any, templateId: string): Observable<Blob> {
  //   return this.httpClient.post(this.PROCESS_HOST_URL + '/api/documenteditor/MergeAndRender/' + templateId,
  //     requestData, { headers: {}, responseType: 'blob' });
  // }
  // renderTemplateToPdf(templateId: string): Observable<Blob> {
  //   return this.httpClient.post(this.PROCESS_HOST_URL + '/api/documenteditor/saveToPdf/' + templateId,
  //     {}, { headers: {}, responseType: 'blob' });
  // }
  // saveBase64DocAsPDF(base64Docx: any): Observable<Blob> {
  //   return this.httpClient.post(this.PROCESS_HOST_URL + '/api/documenteditor/Base64ToPdf',
  //     { documentData: base64Docx }, { headers: {}, responseType: 'blob' });
  // }

  // renderTemplate(requestData: any): Observable<Blob> {
  //   return new Observable<Blob>(subscriber => {
  //     subscriber.next(new Blob());
  //   });
  // }

  // mergeAndGetTemplate(param: any, templateId: string): Observable<Blob> {
  //   return this.httpClient.post(this.PROCESS_HOST_URL + '/api/documenteditor/processAsOdt/' + templateId,
  //     param, { headers: {}, responseType: 'blob' });
  // }
  // getTemplate(templateId: string): Observable<Blob> {
  //   return this.httpClient.post(this.PROCESS_HOST_URL + '/api/documenteditor/saveToOdt/' + templateId,
  //     {}, { headers: {}, responseType: 'blob' });
  // }
  // mergeAndGetBase64(param: any, templateId: string): Observable<string> {
  //   delete param.groupsDataMap;
  //   return this.httpClient.post(this.PROCESS_HOST_URL + '/api/documenteditor/processAsBase64/' + templateId,
  //     param, { headers: {}, responseType: 'text' });
  // }
  // getBase64(templateId: string): Observable<string> {
  //   return this.httpClient.post(this.PROCESS_HOST_URL + '/api/documenteditor/saveToBase64/' + templateId,
  //     {}, { headers: {}, responseType: 'text' });
  // }

  mergeAndRenderToPDFBase64(param: any, requestType: string, requestId: string): Observable<string> {
    delete param.groupsDataMap;
    return this.httpClient.post(`${this.PROCESS_HOST_URL}${'/api/documenteditor/MergeAndRenderBase64'}/${requestType}/${requestId}`,
      param, { headers: {}, responseType: 'text' });
  }

  getRequestData(caseId: string) {
    return this.httpClient.get<any>(`${(this.formioAppConfig as any).gateway}/requestmanagement/api/requests?caseId.equals=${caseId}`);
  }
}
